import isNil from 'lodash/isNil'
import React from 'react'
import { formatMoney } from '@ztechapps/common.utils'
import { HorizontalStack, ShowIf, StatusColorBadge, findStatus } from '@ztechapps/webui.util'
import type { PurchaseOrderPaymentStatusEnum } from '@ztechapps/common.contract'
import { PurchaseOrderPaymentStatus } from '@ztechapps/purchase-order.common'

export const PurchaseOrderPaymentStatusBadge = ({
  paymentStatus,
  balance,
}: {
  paymentStatus: PurchaseOrderPaymentStatusEnum
  balance?: number
}) => {
  const orderPaymentStatus = findStatus(PurchaseOrderPaymentStatus, paymentStatus)
  const balanceDisplay = isNil(balance) || balance === 0 ? null : `(${formatMoney(balance)})`

  return (
    <StatusColorBadge
      pill
      className="px-2"
      color={orderPaymentStatus}
      status={
        <HorizontalStack gap={2}>
          <ShowIf condition={!!paymentStatus}>
            <div>{paymentStatus}</div>
          </ShowIf>
          <ShowIf condition={!!balanceDisplay}>
            <div>{balanceDisplay}</div>
          </ShowIf>
        </HorizontalStack>
      }
    />
  )
}
